import './styles.scss'

import React from 'react'
import { useValues } from 'kea'
import { hot } from 'react-hot-loader'

import OfflineToggleMode from 'lib/components/offline-toggle-mode'

import ContactForm from './contact-form'
import LegalBits from './legal-bits'

import contactLogic from './logic'

const Contact = () => {
  const { showLegal } = useValues(contactLogic)

  return (
    <div className='contact-scene'>
      <OfflineToggleMode />
      <ContactForm />
      {showLegal && <LegalBits />}
    </div>
  )
}

export default hot(module)(Contact)
